if(!customElements.get('sheraton-pet-personalization'))customElements.define('sheraton-pet-personalization',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;this.section=this.closest('section');this.form=this.closest('form');if(!this.form)return;const artwork=this.section.querySelector('input[name="Dog Artwork"]');const artworkField=artwork&&artwork.closest('fieldset');if(artworkField){this.querySelectorAll('input,select,textarea').forEach(control=>control.setAttribute('form',this.form.getAttribute('id')));this.style.order='1';artworkField.after(this);this.addEventListener('change',event=>{this.sync();event.stopPropagation();});}this.breed=this.querySelector('[data-breed] input');this.photo=this.querySelector('[data-photo] input');this.status=this.querySelector('[data-file-status]');this.wording=this.querySelector('[data-wording]');this.petName=this.querySelector('[data-name] input');this.section.addEventListener('change',()=>this.sync());this.form.addEventListener('submit',e=>{this.sync();if(!this.form.checkValidity()){e.preventDefault();e.stopImmediatePropagation();this.form.reportValidity();}},true);this.sync();}
sync(){const a=this.section.querySelector('input[name="Dog Artwork"]:checked');const custom=Boolean(a&&a.value.startsWith('Custom'));this.querySelector('[data-breed]').hidden=custom;this.breed.disabled=custom;this.breed.required=!custom;this.breed.setCustomValidity(!custom&&!this.breed.value.trim()?'Enter a breed name or chart number.':'');this.querySelector('[data-photo]').hidden=!custom;this.photo.disabled=!custom;this.photo.required=custom;if(this.petName){const n=this.wording.value==='Dog name';this.querySelector('[data-name]').hidden=!n;this.petName.disabled=!n;this.petName.required=n;this.petName.setCustomValidity(n&&!this.petName.value.trim()?'Enter your dog’s name.':'');}this.photo.setCustomValidity('');const f=this.photo.files[0];if(custom&&f){if(!/\.(jpe?g|png)$/i.test(f.name)||!['image/jpeg','image/png',''].includes(f.type))this.photo.setCustomValidity('Choose a JPG or PNG photo.');if(f.size>10485760)this.photo.setCustomValidity('Choose a photo smaller than 10 MB.');}this.status.textContent=custom&&f?(this.photo.validity.customError ? this.photo.validationMessage : 'Selected: '+f.name+'. Uploaded when you add to cart.') :'';}
});
document.addEventListener('submit', async function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  const panel = Array.from(
    document.querySelectorAll('sheraton-pet-personalization')
  ).find(element => element.form === form);

  if (!panel) return;
  event.preventDefault();
  event.stopImmediatePropagation();

  if (form.dataset.petUploading === 'true') return;
  panel.sync();
  if (!form.reportValidity()) return;

  const data = new FormData(form);
  panel.querySelectorAll('input,select,textarea').forEach(control => {
    if (control.disabled || !control.name) return;
    if (control.type === 'file') {
      if (control.files[0]) data.set(control.name, control.files[0]);
    } else {
      data.set(control.name, control.value);
    }
  });

  const status = panel.querySelector('[data-file-status]');
  const photo = panel.querySelector('[data-photo] input');
  const needsPhoto = !photo.disabled;
  const button = form.querySelector('[type="submit"]');

  form.dataset.petUploading = 'true';
  if (button) button.disabled = true;
  status.textContent = 'Adding your decal…';

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    const item = await response.json();

    if (!response.ok || item.status) {
      throw new Error(item.description || 'Could not add the decal.');
    }

    const added = item.items || [item];
    if (needsPhoto && !added.some(line =>
      line.properties && line.properties['Pet photo']
    )) {
      throw new Error(
        'The decal was added, but the photo is missing. Remove that cart item before trying again.'
      );
    }

    window.location.assign(root + 'cart');
  } catch (error) {
    status.textContent = error.message || 'Upload failed. Please try again.';
    status.scrollIntoView({ block: 'center', behavior: 'smooth' });
  } finally {
    form.dataset.petUploading = 'false';
    if (button) button.disabled = false;
  }
}, true);
window.addEventListener('click', function (event) {
  const button = event.target.closest?.('[id^="ProductSubmitButton-"]');
  if (!button || button.disabled) return;
  const form = button.form;
  const panel = Array.from(
    document.querySelectorAll('sheraton-pet-personalization')
  ).find(element => element.form === form);
  if (!panel) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  form.requestSubmit(button);
}, true);